import { IotizeVariableModel } from './iotize-variable-model';
import { IotizeProfileModel } from './iotize-profile-model';
import {
  IotizeConfigModel,
  VariableDoesNotExistError,
} from './iotize-config-model';
import { InvalidConfigurationError } from './invalid-configuration-error';
import { IotizeACLGroup } from './iotize-acl-group';

export class IotizeBundleModel {
  public data: any;
  public iotizeModule: IotizeConfigModel;

  constructor(data: any, iotizeModule: IotizeConfigModel) {
    this.data = data;
    this.iotizeModule = iotizeModule;
  }

  public toJson() {
    return this.data;
  }

  public module() {
    return this.iotizeModule;
  }

  public id(): string {
    if (!this.data.$.Id) {
      throw new InvalidConfigurationError('This bundle does not have an id');
    }
    return this.data.$.Id;
  }

  public name(): string {
    return this.data.$.GUI_Name || '#' + this.id();
  }

  public dataLogPeriod(): number {
    if (!this.data.$.DataLogPeriod) {
      return 0;
    }
    return Number(this.data.$.DataLogPeriod);
  }

  public hasDataLog(): boolean {
    return this.dataLogPeriod() > 0;
  }

  public description(): string {
    return this.data.$.GUI_Description;
  }

  public variable(variableId: string): IotizeVariableModel {
    for (let variable of this.variables()) {
      if (variable.id() === variableId) {
        return variable;
      }
    }
    throw new VariableDoesNotExistError(variableId, this.iotizeModule);
  }

  public hasVariable(variableId: string): IotizeVariableModel | false {
    for (let variable of this.variables()) {
      if (variable.id() === variableId) {
        return variable;
      }
    }
    return false;
  }

  public profiles(): Array<IotizeProfileModel> {
    if (!this.data.IOTizeAccessControl) {
      return [];
    }
    let profiles = [];
    for (let profile of this.data.IOTizeAccessControl) {
      profiles.push(new IotizeProfileModel(profile));
    }
    return profiles;
  }

  public variables(): Array<IotizeVariableModel> {
    if (!this.data.IOTizeVariable) {
      return [];
    }
    let variables = [];
    for (let variable of this.data.IOTizeVariable) {
      variables.push(
        new IotizeVariableModel(variable, this.iotizeModule, this),
      );
    }
    return variables;
  }

  public getACLGroup(): IotizeACLGroup {
    let data = {};
    if (!this.data.IOTizeAccessControl) {
      this.data.IOTizeAccessControl = [];
    }
    if (this.data.IOTizeAccessControl.length > 0) {
      data = this.data.IOTizeAccessControl[0];
    }
    return new IotizeACLGroup(data, this);
  }
}
